export const HIDDEN_TEXTAREA_STYLE = {
   "min-height": "0",
   "max-height": "none",
   height: "0",
   visibility: "hidden",
   overflow: "hidden",
   position: "absolute",
   "z-index": "-1000",
   top: "0",
   right: "0",
   display: "block",
} as const

export const SIZING_STYLE = [
   "borderBottomWidth",
   "borderLeftWidth",
   "borderRightWidth",
   "borderTopWidth",
   "boxSizing",
   "fontFamily",
   "fontSize",
   "fontStyle",
   "fontWeight",
   "letterSpacing",
   "lineHeight",
   "paddingBottom",
   "paddingLeft",
   "paddingRight",
   "paddingTop",
   // non-standard
   "tabSize",
   "textIndent",
   // non-standard
   "textRendering",
   "textTransform",
   "width",
   "wordBreak",
   "wordSpacing",
   "scrollbarGutter",
] as const
